import React from 'react';
import { Flex, Tag } from '@fullstory/components';
import css from './index.module.scss';

export interface TagTabsOptions<T> {
  id: T;
  name: string;
}

export function TagTabs<T extends string>({
  options,
  onSelect,
  selected,
}: {
  options: TagTabsOptions<T>[];
  selected: string;
  onSelect: (id: T) => void;
}) {
  return (
    <Flex
      data-component="TagTabs"
      justifyContent="center"
      flexWrap="wrap"
      className={css.tabContainer}
    >
      {options.map(o => (
        <Tag
          active={selected === o.id}
          aria-selected={selected === o.id}
          id={o.id}
          key={o.id}
          onClick={() => onSelect(o.id)}
          role="tab"
          testId={`${o.name.toLowerCase()}-tab`}
        >
          {o.name}
        </Tag>
      ))}
    </Flex>
  );
}
